var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
      label: 0,
      sent: function () {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (g && (g = 0, op[0] && (_ = 0)), _) try {
      if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
      if (y = 0, t) op = [op[0] & 2, t.value];
      switch (op[0]) {
        case 0:
        case 1:
          t = op;
          break;
        case 4:
          _.label++;
          return {
            value: op[1],
            done: false
          };
        case 5:
          _.label++;
          y = op[1];
          op = [0];
          continue;
        case 7:
          op = _.ops.pop();
          _.trys.pop();
          continue;
        default:
          if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
            _ = 0;
            continue;
          }
          if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
            _.label = op[1];
            break;
          }
          if (op[0] === 6 && _.label < t[1]) {
            _.label = t[1];
            t = op;
            break;
          }
          if (t && _.label < t[2]) {
            _.label = t[2];
            _.ops.push(op);
            break;
          }
          if (t[2]) _.ops.pop();
          _.trys.pop();
          continue;
      }
      op = body.call(thisArg, _);
    } catch (e) {
      op = [6, e];
      y = 0;
    } finally {
      f = t = 0;
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Skeleton, TableBody, TableCell, TableRow, inputBaseClasses } from '@mui/material';
import { debounce } from 'lodash';
import { useCallback, useContext, useEffect, useMemo, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useStore } from 'react-redux';
import { WizardTable, getWizardTableSx } from '../../common/WizardTable';
import { waitForApiSliceTerminal } from '../../common/waitForApiSliceTerminal';
import { OrgConfigWizardContext } from '../../context';
import { TimeSelect } from '../../hours/LocationConfigPanel';
import { TIME_24H, TIME_CLOSED, TIME_MIDNIGHT, useLocationHoursBatchAPI, useSaveLocationHoursBatchAPI } from '../../hours/selectors';
import { ORDERED_DAYS } from '../../hours/types';
var toBaseline = function (f) {
  return {
    days: f.days.map(function (d) {
      return __assign({}, d);
    })
  };
};
var baselinesEqual = function (a, b) {
  return a.days.length === b.days.length && a.days.every(function (d, i) {
    var o = b.days[i];
    return d.dayOfWeek === o.dayOfWeek && d.isAvailable === o.isAvailable && d.startTime === o.startTime && d.endTime === o.endTime;
  });
};
var mapBatchToForm = function (batch) {
  return {
    days: ORDERED_DAYS.map(function (d) {
      var _a, _b, _c;
      var found = batch.hours.find(function (h) {
        return h.dayOfWeek === d.key;
      });
      return {
        dayOfWeek: d.key,
        isAvailable: (_a = found === null || found === void 0 ? void 0 : found.isAvailable) !== null && _a !== void 0 ? _a : false,
        startTime: (_b = found === null || found === void 0 ? void 0 : found.startTime) !== null && _b !== void 0 ? _b : null,
        endTime: (_c = found === null || found === void 0 ? void 0 : found.endTime) !== null && _c !== void 0 ? _c : null
      };
    }),
    isDirty: false
  };
};
/** Resolve a select value back to API fields. */
var resolveTimeChoice = function (value, field) {
  var _a;
  if (value === TIME_CLOSED) return {
    isAvailable: false,
    startTime: null,
    endTime: null
  };
  if (value === TIME_24H) return {
    isAvailable: true,
    startTime: TIME_MIDNIGHT,
    endTime: TIME_MIDNIGHT
  };
  return _a = {
    isAvailable: true
  }, _a[field] = value, _a;
};
/** Build the select value displayed for a day/field. */
var getSelectValue = function (day, field) {
  if (!day.isAvailable) return TIME_CLOSED;
  var time = day[field];
  if (time === TIME_24H) return TIME_24H;
  return time;
};
var HoursTimeRow = function (_a) {
  var label = _a.label,
    field = _a.field,
    days = _a.days,
    onDayChange = _a.onDayChange,
    tHours = _a.tHours,
    disabled = _a.disabled;
  return _jsxs(TableRow, {
    children: [_jsx(TableCell, __assign({
      sx: {
        textTransform: 'uppercase',
        minWidth: 100,
        bgcolor: 'background.default'
      }
    }, {
      children: label
    })), ORDERED_DAYS.map(function (d) {
      var day = days.find(function (dd) {
        return dd.dayOfWeek === d.key;
      });
      return _jsx(TableCell, {
        children: day && _jsx(TimeSelect, __assign({
          fullWidth: true,
          disabled: disabled,
          value: getSelectValue(day, field),
          onChange: function (v) {
            return onDayChange(d.key, field, v);
          },
          placeholder: tHours("schedule.".concat(field))
        }, field === 'endTime' ? {
          minTime: day.startTime,
          isEndTime: true
        } : {}))
      }, d.key);
    })]
  });
};
export var ReviewHoursSection = function (_a) {
  var _b;
  var locationId = _a.locationId,
    registry = _a.registry;
  var tReview = useTranslation('orgConfig', {
    keyPrefix: 'orgConfigWizard.reviewStep'
  }).t;
  var tHours = useTranslation('orgConfig', {
    keyPrefix: 'hours'
  }).t;
  var store = useStore();
  var _c = useContext(OrgConfigWizardContext),
    configVersionId = _c.configVersionId,
    _d = _c.isReadOnly,
    isReadOnly = _d === void 0 ? false : _d;
  var _e = useLocationHoursBatchAPI(configVersionId),
    hoursBatchData = _e[0],
    fetchHoursBatch = _e[1];
  var hoursBatch = useMemo(function () {
    var _a;
    return (_a = hoursBatchData.data) !== null && _a !== void 0 ? _a : [];
  }, [hoursBatchData.data]);
  var _f = useState({}),
    formMap = _f[0],
    setFormMap = _f[1];
  var formMapRef = useRef(formMap);
  useEffect(function () {
    formMapRef.current = formMap;
  }, [formMap]);
  var baselineRef = useRef({});
  var _g = useSaveLocationHoursBatchAPI(),
    doSaveBatch = _g[1];
  var doSaveBatchRef = useRef(doSaveBatch);
  useEffect(function () {
    doSaveBatchRef.current = doSaveBatch;
  }, [doSaveBatch]);
  useEffect(function () {
    if (configVersionId) fetchHoursBatch();
  }, [configVersionId, locationId, fetchHoursBatch]);
  var locationHours = hoursBatch.find(function (h) {
    return h.locationId === locationId;
  });
  var form = (_b = formMap[locationId]) !== null && _b !== void 0 ? _b : null;
  // Populate form from batch data
  useEffect(function () {
    if (!locationHours) return;
    setFormMap(function (prev) {
      var _a;
      var _b;
      if ((_b = prev[locationId]) === null || _b === void 0 ? void 0 : _b.isDirty) return prev;
      var mapped = mapBatchToForm(locationHours);
      baselineRef.current[locationId] = toBaseline(mapped);
      return __assign(__assign({}, prev), (_a = {}, _a[locationId] = mapped, _a));
    });
  }, [locationHours, locationId]);
  var handleDayChange = useCallback(function (dayKey, field, value) {
    setFormMap(function (prev) {
      var _a;
      var current = prev[locationId];
      if (!current) return prev;
      var days = current.days.map(function (d) {
        if (d.dayOfWeek !== dayKey) return d;
        return __assign(__assign({}, d), resolveTimeChoice(value, field));
      });
      return __assign(__assign({}, prev), (_a = {}, _a[locationId] = {
        days: days,
        isDirty: true
      }, _a));
    });
  }, [locationId]);
  var doSave = useCallback(function (locId) {
    return __awaiter(void 0, void 0, void 0, function () {
      var f, baseline, apiDays, ok;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            f = formMapRef.current[locId];
            if (!(f === null || f === void 0 ? void 0 : f.isDirty)) return [2 /*return*/, true];
            baseline = baselineRef.current[locId];
            if (baseline && baselinesEqual(toBaseline(f), baseline)) {
              setFormMap(function (prev) {
                var _a;
                return __assign(__assign({}, prev), (_a = {}, _a[locId] = __assign(__assign({}, f), {
                  isDirty: false
                }), _a));
              });
              return [2 /*return*/, true];
            }
            apiDays = f.days.map(function (d) {
              return d.isAvailable && d.startTime && d.endTime ? d : __assign(__assign({}, d), {
                isAvailable: false,
                startTime: null,
                endTime: null
              });
            });
            return [4 /*yield*/, waitForApiSliceTerminal(store, 'saveLocationHoursBatch:POST', function () {
              return doSaveBatchRef.current({
                locations: [{
                  locationId: locId,
                  days: apiDays
                }]
              });
            })];
          case 1:
            ok = _a.sent();
            if (ok) {
              baselineRef.current[locId] = toBaseline(f);
              setFormMap(function (prev) {
                var _a;
                return __assign(__assign({}, prev), (_a = {}, _a[locId] = __assign(__assign({}, f), {
                  isDirty: false
                }), _a));
              });
            }
            return [2 /*return*/, ok];
        }
      });
    });
  }, [store]);
  var scheduleDebouncedSave = useMemo(function () {
    return debounce(function (locId) {
      void doSave(locId);
    }, 500);
  }, [doSave]);
  useEffect(function () {
    if (!(form === null || form === void 0 ? void 0 : form.isDirty)) return;
    scheduleDebouncedSave(locationId);
  }, [form === null || form === void 0 ? void 0 : form.isDirty, form === null || form === void 0 ? void 0 : form.days, locationId, scheduleDebouncedSave]);
  useEffect(function () {
    registry.register('hours', {
      flush: function () {
        return __awaiter(void 0, void 0, void 0, function () {
          return __generator(this, function (_a) {
            scheduleDebouncedSave.cancel();
            return [2 /*return*/, doSave(locationId)];
          });
        });
      },
      cancelPending: function () {
        return scheduleDebouncedSave.cancel();
      },
      get isDirty() {
        var _a, _b;
        return (_b = (_a = formMapRef.current[locationId]) === null || _a === void 0 ? void 0 : _a.isDirty) !== null && _b !== void 0 ? _b : false;
      }
    });
    return function () {
      return registry.unregister('hours');
    };
  }, [registry, locationId, scheduleDebouncedSave, doSave]);
  if (!form) return _jsx(Skeleton, {
    variant: "rectangular",
    height: 200,
    sx: {
      borderRadius: 1
    }
  });
  var tableSx = function (theme) {
    var _a;
    return __assign(__assign({}, getWizardTableSx(theme)), (_a = {}, _a["& td:not(:first-of-type), & th:not(:first-of-type)"] = {
      textAlign: 'center'
    }, _a["& td:not(:first-of-type) .".concat(inputBaseClasses.input)] = {
      textAlign: 'center'
    }, _a));
  };
  return _jsx(WizardTable, __assign({
    tableSx: tableSx,
    headers: _jsxs(_Fragment, {
      children: [_jsx(TableCell, {
        sx: {
          minWidth: 100
        }
      }), ORDERED_DAYS.map(function (d) {
        return _jsx(TableCell, {
          children: tHours(d.labelKey)
        }, d.key);
      })]
    })
  }, {
    children: _jsxs(TableBody, {
      children: [_jsx(HoursTimeRow, {
        label: tReview('open'),
        field: "startTime",
        days: form.days,
        onDayChange: handleDayChange,
        tHours: tHours,
        disabled: isReadOnly
      }), _jsx(HoursTimeRow, {
        label: tReview('close'),
        field: "endTime",
        days: form.days,
        onDayChange: handleDayChange,
        tHours: tHours,
        disabled: isReadOnly
      })]
    })
  }));
};